<template>
  <div class="center">Send Email ... {{ status }}</div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/lib/loading";

export default {
  name: "SendEmail",
  props: {
    code: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      status: "(Please wait)",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.callCCMService();
    });
  },
  methods: {
    async callCCMService() {
      axios
        .get(
          process.env.VUE_APP_ROOT_API +
            "/api/email/sendEmail/" +
            this.code +
            "/" +
            this.type
        )
        .then((resp) => {
          console.log(resp);
          if (resp.data) {
            if (resp.data.code === "0000") {
              this.status = "(Success)";
              this.$swal("", "จัดส่ง Email สำเร็จ", "success").then(
                (result) => {
                  window.close();
                }
              );
            } else if (resp.data.code === "4001") {
              this.status = "(Success)";
              this.$swal("", resp.data.message, "error").then((result) => {
                window.close();
              });
            } else if (resp.data.code === "4000") {
              //this.$swal( "Confirm", "ยืนยันการทำรายการ", "info")
              this.$swal
                .fire({
                  title: "ยืนยันการขอรหัส Authentication Code",
                  html: resp.data.message,
                  type: "warning",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  showCancelButton: true,
                })
                .then((result) => {
                  if (result.value) {
                    //continue
                    this.type = "confirm";
                    this.callCCMService();
                  } else {
                    //close
                    window.close();
                  }
                })
                .then((result) => {});
            } else {
              this.status = "(" + resp.data.message + ")";
              this.$swal(
                "",
                "จัดส่ง Email ไม่สำเร็จ กรุณาติดต่อธนาคาร",
                "error"
              ).then((result) => {
                window.close();
              });
            }
          } else {
            this.status = "(" + resp.data.message + ")";
            this.$swal(
              "",
              "จัดส่ง Email ไม่สำเร็จ กรุณาติดต่อธนาคาร",
              "error"
            ).then((result) => {
              window.close();
            });
          }
        })
        .catch((error) => {
          this.status = "(Something wrong)";
          this.$swal(
            "Error",
            "จัดส่ง Email ไม่สำเร็จ กรุณาติดต่อธนาคาร",
            "error"
          ).then((result) => {
            window.close();
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center {
  text-align: center;
  padding-top: 10%;
}
</style>
